module.exports = __webpack_public_path__ + "img/hopital-montfort.a5ec35d1.webp";